<template>
  <div
    class="relative flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-full"
  >
    <div
      class="flex h-5 w-5 items-center justify-center rounded-full border-2"
      :class="[isChecked && 'border-primary', !isChecked && 'border-on-surface-variant']"
    >
      <div
        class="bg-primary h-2.5 w-2.5 rounded-full transition-transform"
        :class="[isChecked && 'scale-100', !isChecked && 'scale-0']"
      ></div>
    </div>
    <BaseStateLayer v-if="showStateLayer" />
  </div>
</template>
<script setup lang="ts">
  import BaseStateLayer from '../state-layer/BaseStateLayer.vue'

  interface Props {
    isChecked: boolean
    disabled?: boolean
    showStateLayer?: boolean
  }

  defineProps<Props>()
</script>
